import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rejectAccountDocument } from '../endpoints/accountDocument.ts';
import { ACCOUNT_DOCUMENT_QUERY_NAMESPACE } from './useAccountDocumentList.ts';

const useRejectAccountDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason: string }) =>
      rejectAccountDocument(id, reason),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: [ACCOUNT_DOCUMENT_QUERY_NAMESPACE],
      }),
  });
};

export { useRejectAccountDocument };
